import React, { useState } from 'react';
import PropTypes from 'prop-types';

import EmailPasswordControlSet from '../../ControlSets/EmailPasswordControlSet/EmailPasswordControlSet';
import { UamErrorText, UamErrorTextContainer } from '../../../../styles-and-themes/styles/uam-registration-styles';
import LoginForgotControlSet from '../../ControlSets/LoginForgotControlSet/LoginForgotControlSet';

const LoginPanel = ({ destPath }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const isFormValid = email.length > 0 && password.length > 0;

  const onLogin = () => {
    console.log('onLogin');
  };

  return (
    <>
      <UamErrorTextContainer><UamErrorText>All fields are required</UamErrorText></UamErrorTextContainer>

      <EmailPasswordControlSet
        email={email}
        setEmail={setEmail}
        password={password}
        setPassword={setPassword}
      />

      <LoginForgotControlSet
        onLogin={onLogin}
        isFormValid={isFormValid}
        destPath={destPath}
      />
    </>
  );
};

LoginPanel.propTypes = {
  destPath: PropTypes.shape({
    dest: PropTypes.string,
    path: PropTypes.string,
    retURL: PropTypes.string,
  }).isRequired,
};

export default LoginPanel;